import { createSlice } from "@reduxjs/toolkit";
import { fetchProducts, fetchGroceryLists, saveGroceryList } from "./manavThunks";

const initialState = {
  catalog: [],
  savedLists: [],
  page: 1,
  size: 10,
  count: 0,
  totalPages: 0,
  hasNext: false,
  hasPrev: false,
  loading: false,
  saving: false,
  error: null,
};

const manavSlice = createSlice({
  name: "manav",
  initialState,
  reducers: {
    // Keep local actions if needed for UI, otherwise leave empty
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Products
      .addCase(fetchProducts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProducts.fulfilled, (state, action) => {
        state.loading = false;
        state.catalog = action.payload || [];
      })
      .addCase(fetchProducts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Fetch Grocery Lists
      .addCase(fetchGroceryLists.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchGroceryLists.fulfilled, (state, action) => {
        state.loading = false;
        state.savedLists = action.payload.items || [];
        state.page = action.payload.page;
        state.size = action.payload.size;
        state.count = action.payload.count;
        state.totalPages = action.payload.totalPages;
        state.hasNext = action.payload.hasNext;
        state.hasPrev = action.payload.hasPrev;
      })
      .addCase(fetchGroceryLists.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Save Grocery List
      .addCase(saveGroceryList.pending, (state) => {
        state.saving = true;
        state.error = null;
      })
      .addCase(saveGroceryList.fulfilled, (state) => {
        state.saving = false;
      })
      .addCase(saveGroceryList.rejected, (state, action) => {
        state.saving = false;
        state.error = action.payload;
      });
  },
});

export const { clearError } = manavSlice.actions;
export default manavSlice.reducer;
